module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/logo-2bf8389a386bbd5d6001c796e90d0bb4.jpg";